import { FC } from 'react'
import * as styles from 'components/features/pfm/OptOutModal/OptOutModal.css'
import { CC_SUPPORT_PHONE_NUMBER } from 'components/features/creditCard/creditCardStore/constants'
import { ShowOptOutModalActionButton } from 'components/features/pfm/Button/ActionButtons'
import Button from 'components/features/pfm/Button/Button'
import Modal from 'components/features/pfm/Modal.tsx/Modal'

export type OptOutModalStateProps = {
  modalShown: boolean
}

export type OptOutModalDispatchProps = {
  hideModal: () => void
}

type OptOutModalProps = OptOutModalStateProps & OptOutModalDispatchProps

const OptOutModal: FC<OptOutModalProps> = (props) => {
  const { modalShown, hideModal } = props

  const confirmModal = modalShown ? (
    <Modal
      onCancel={ hideModal }
      primaryButton={ <Button onClick={ hideModal } text='Close' /> }
    >
      For changes to your electronic communications, contact customer service at { CC_SUPPORT_PHONE_NUMBER }.
    </Modal>
  ) : null

  return (
    <div className={ styles.optOutModal }>
      { confirmModal }
      <br />
      <small>
        <ShowOptOutModalActionButton text='Manage electronic communications' renderAsLink />
      </small>
    </div>
  )
}

export default OptOutModal
